export default function AdminStat({ label, v, icon, accent, onClick, testid }) {
  const interactive = typeof onClick === "function";
  const Tag = interactive ? "button" : "div";
  return (
    <Tag
      type={interactive ? "button" : undefined}
      onClick={onClick}
      className={
        "zc-card p-4 text-left w-full"
        + (interactive ? " cursor-pointer hover:border-[var(--zc-accent)] transition-colors" : "")
      }
      data-testid={testid}
    >
      <div className="flex items-center gap-2 eyebrow" style={{ color: accent ? "var(--zc-accent)" : undefined }}>{icon}{label}</div>
      <div className="zc-stat text-3xl mt-2">{v ?? "—"}</div>
    </Tag>
  );
}
